import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { PFieldAbstractWorkaroundComponent } from '../p-field-abstract-workaround';

@Component({
    selector: 'p-field-slide-toggle-workround',
    template: ` <p-field
        [isMandatory]="isMandatory"
        [label]="label"
        [labelTooltip]="labelTooltip"
        [isReadOnly]="isReadOnly"
        [isDisable]="isDisabled"
        [customClasses]="customClasses"
        [shouldShowLabel]="shouldShowLabel"
        [shouldTransformLabelTextCase]="shouldTransformLabelTextCase"
    >
        <p-slide-toggle
            slot="readMode"
            [checked]="value"
            [disabled]="true"
            [labelOff]="toggleOffText"
            [labelOn]="toggleOnText"
        ></p-slide-toggle>

        <p-slide-toggle
            slot="editMode"
            [checked]="value"
            [labelOff]="toggleOffText"
            [labelOn]="toggleOnText"
            (toggleChanged)="changeValue($event)"
        ></p-slide-toggle>
    </p-field>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs: 'pFieldSlideToggle',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: PFieldSlideToggleWorkaroundComponent
        }
    ]
})
export class PFieldSlideToggleWorkaroundComponent<T> extends PFieldAbstractWorkaroundComponent<T> {
    @Input() label?: string;
    @Input() isMandatory = false;
    @Input() textCustomClass?: string;

    @Input() customClasses?: string;
    @Input() shouldShowLabel = true;
    @Input() toggleOffText: string = 'No';
    @Input() toggleOnText: string = 'Yes';

    get classes(): object {
        return {
            textCustomClass: true
        };
    }

    constructor(cd: ChangeDetectorRef) {
        super(cd);
    }

    changeValue(value: boolean) {
        this.markAsTouched();

        if (!this.isReadOnly) {
            this.value = value;
            this._onChange(value);
        }
    }
}
